module.exports = __webpack_public_path__ + "media/icons/key-3-dark-35a3e8d4.svg";